import React from 'react';
import { LINKS } from '../lib/links';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative min-h-[92vh] flex flex-col justify-end pb-24 pt-24 px-6 md:px-12 overflow-hidden bg-charcoal" data-id="element-103">
      {/* Background Image with Cinematic Overlays */}
      <div className="absolute inset-0 z-0" data-id="element-104">
        <img src="https://cdn.magicpatterns.com/uploads/159D69XqkjH3tXZBxvtdbs/544792890_122198079740570946_7016239850407119729_n_(1).jpg" alt="Sauna at night with steam rising from the chimney" className="w-full h-full object-cover object-center" data-id="element-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/70 to-charcoal/30 mix-blend-multiply" data-id="element-106" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/50 to-transparent" data-id="element-107" />
      </div>

      {/* Top-left wordmark */}
      <div className="absolute top-6 left-6 md:top-8 md:left-12 z-20" data-id="element-108">
        <FadeIn delay={0.1} data-id="element-109">
          <span className="font-serif text-offwhite text-lg md:text-xl tracking-wide" data-id="element-110">
            Pines Retreat
          </span>
        </FadeIn>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto w-full" data-id="element-111">
        <FadeIn delay={0.3} data-id="element-112">
          <p className="text-sand/80 uppercase tracking-[0.2em] text-xs font-medium mb-6" data-id="element-113">
            Near Pardes Hanna / Kfar Pines
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-114">
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-offwhite leading-[1.05] mb-8" data-id="element-115">
            Gather. Sweat.
            <br data-id="element-116" />
            Breathe. Reset.
          </h1>
        </FadeIn>

        <FadeIn delay={0.7} data-id="element-117">
          <p className="text-lg md:text-xl text-sand/90 max-w-2xl leading-relaxed mb-12 font-light" data-id="element-118">
            A retreat space for deep rest, connection, sauna, cold water, music,
            and overnight stays.
          </p>
        </FadeIn>

        <FadeIn delay={0.9} className="flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-119">
          <a href="#stay" className="inline-flex items-center justify-center px-7 py-4 bg-ember text-cream rounded-sm font-medium tracking-wide hover:bg-ember/90 transition-colors" data-id="element-120">
            Stay at the Retreat
          </a>
          <a href="#experiences" className="inline-flex items-center justify-center px-7 py-4 bg-transparent border border-cream/30 text-cream rounded-sm font-medium tracking-wide hover:bg-cream/10 transition-colors" data-id="element-121">
            Events & Experiences
          </a>
          <a href="#location" className="inline-flex items-center justify-center px-7 py-4 bg-transparent border border-cream/30 text-cream rounded-sm font-medium tracking-wide hover:bg-cream/10 transition-colors" data-id="element-122">
            Our Location
          </a>
        </FadeIn>
      </div>
    </section>;
}